import request from '../../../../../api/request';

import { InstallmentSettings } from './types';

const BASE = '/maintainers-portal/financial-portal/settings/installments';

export function getInstallmentSettings() {
  return request<InstallmentSettings>(BASE);
}

export function saveInstallmentSettings(body: InstallmentSettings) {
  return request<InstallmentSettings>(BASE, { method: 'put', data: body });
}
